import { render, staticRenderFns } from "./NotificationAppointmentNoResponse.vue?vue&type=template&id=d6fb0818&"
import script from "./NotificationAppointmentNoResponse.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentNoResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports